import React from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import { Section, H4, Space, Content } from "AtomicComponents"
import componentParser from "AtomicUtils/componentParser"

const MyMazdaDynamicResourceBlock = props => (
  <Section padding backgroundColor={props.backgroundColor}>
    <H4 withDetails>{props.heading}</H4>
    <Space />
    <Content xmlString={props.description} />
    <div style={styles.list}>{componentParser(props.components, { gtm: { category: props.heading }})}</div>
  </Section>
)

const styles = {
  list: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "3em"
  }
}

MyMazdaDynamicResourceBlock.propTypes = {
  components: PropTypes.array,
  heading: PropTypes.string,
  description: PropTypes.string,
  backgroundColor: PropTypes.string
}

MyMazdaDynamicResourceBlock.defaultProps = {
  backgroundColor: COLOR_PALETTE.WHITE
}

export default MyMazdaDynamicResourceBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/dynamic-resource/index.jsx